export const keycloakConfig = {
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  url: process.env.REACT_APP_KEYCLOAK_URL,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT
};

export const baseURL = process.env.REACT_APP_API_BASE_URL;

export const TimeOfBinCreationLimit = 8;

export const REACTS3URL = process.env.REACT_APP_S3_URL;

export const REACTS3SHAPEFILESURL = process.env.REACT_APP_S3_SHAPEFILES_URL;

export const REACTS3PERFORMANCE_REPORTS_URL = process.env.REACT_APP_S3_PERFORMANCE_REPORTS_URL;

export const S3_SELECT_LINK_URL = process.env.REACT_APP_S3_SELECT_LINK_URL;
